module.exports = __webpack_public_path__ + "static/img/point_5.89fe3b14.png";